var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.00006,
    r: 8,
    fill: "#EFDBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61487 3.01605C3.95142 3.01605 4.22424 3.28888 4.22424 3.62543V5.45355H6.05237C6.38892 5.45355 6.66174 5.72638 6.66174 6.06293C6.66174 6.39948 6.38892 6.6723 6.05237 6.6723H3.61487C3.27832 6.6723 3.00549 6.39948 3.00549 6.06293V3.62543C3.00549 3.28888 3.27832 3.01605 3.61487 3.01605Z",
    fill: "#722ED1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51039 2.51982C8.49556 2.32354 9.51681 2.42386 10.445 2.80809C11.3731 3.19232 12.1664 3.84319 12.7246 4.67838C13.2828 5.51356 13.5807 6.49553 13.5807 7.50006C13.5807 8.5046 13.2828 9.48657 12.7246 10.3217C12.1664 11.1569 11.3731 11.8078 10.445 12.192C9.51681 12.5763 8.49556 12.6766 7.51039 12.4803C6.52521 12.284 5.62039 11.8 4.91036 11.0894C4.67248 10.8513 4.67264 10.4655 4.91071 10.2276C5.14879 9.98971 5.53462 9.98987 5.7725 10.2279C6.31212 10.768 6.99979 11.1359 7.74852 11.2851C8.49725 11.4342 9.2734 11.358 9.9788 11.066C10.6842 10.7739 11.2871 10.2793 11.7113 9.64454C12.1356 9.00981 12.362 8.26351 12.362 7.50006C12.362 6.73662 12.1356 5.99032 11.7113 5.35558C11.2871 4.72084 10.6842 4.22618 9.9788 3.93416C9.2734 3.64215 8.49725 3.56591 7.74852 3.71508C6.99979 3.86425 6.31212 4.23213 5.7725 4.77219L4.04513 6.49448C3.8068 6.73211 3.42097 6.73154 3.18334 6.49321C2.94572 6.25489 2.94628 5.86905 3.18461 5.63143L4.91036 3.91075C4.91051 3.9106 4.91066 3.91046 4.91081 3.91031C5.62076 3.19995 6.52542 2.71605 7.51039 2.51982Z",
    fill: "#722ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.da7e204d.svg";
export { ForwardRef as ReactComponent };